import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { CONTACT_EMAIL } from "../data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro:
      "Inceptica respects your privacy. This summary explains, in plain language, how we handle information across our website and products.",
    sections: [
      {
        h: "Information we collect",
        p: "We collect only the information you choose to share with us — for example, when you email us or request a discussion. We do not sell your personal information.",
      },
      {
        h: "How we use information",
        p: "We use the information you provide to respond to enquiries, coordinate discussions and improve our products and services.",
      },
      {
        h: "Data protection",
        p: "Security and compliance are core to how we build. We apply enterprise-grade safeguards to protect the information entrusted to us.",
      },
      {
        h: "Contact",
        p: `For any privacy questions, reach us at ${CONTACT_EMAIL}.`,
      },
    ],
  },
  terms: {
    title: "Terms of Use",
    intro:
      "By using this website you agree to the following terms. These govern your access to and use of Inceptica's website and content.",
    sections: [
      {
        h: "Use of the site",
        p: "This website is provided for informational purposes. Content may change without notice.",
      },
      {
        h: "Intellectual property",
        p: "All trademarks, product names and content on this site — including Nova — are the property of Inceptica or their respective owners.",
      },
      {
        h: "Products",
        p: "Access to Nova is governed by its own terms available on the Nova website.",
      },
      {
        h: "Contact",
        p: `For any questions about these terms, reach us at ${CONTACT_EMAIL}.`,
      },
    ],
  },
};

export default function LegalPage({ type = "privacy" }) {
  const data = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="relative min-h-screen bg-white" data-testid={`legal-page-${type}`}>
      <Navbar />
      <main className="relative pt-32 pb-24">
        <div className="absolute inset-0 nova-glow pointer-events-none" aria-hidden="true" />
        <div className="relative mx-auto max-w-3xl px-6 lg:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-zinc-900 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <h1 className="mt-8 font-display text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900">
            {data.title}
          </h1>
          <p className="mt-5 text-base text-zinc-600 leading-relaxed">{data.intro}</p>

          <div className="mt-12 space-y-10">
            {data.sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl font-medium text-zinc-900">{s.h}</h2>
                <p className="mt-3 text-base text-zinc-600 leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
